import { useTranslation } from "@/packages/utils";
import { useConfirmDialogContext } from "./ConfirmDialogContext";
import type { ConfirmDialogActionsProps } from "./types";
import { Button } from "../primitives";

export function ConfirmDialogActions({
  onConfirm,
  onCancel,
  confirmLabel,
  cancelLabel,
  variant = "default",
  loading = false,
  confirmDisabled = false,
}: ConfirmDialogActionsProps) {
  const { t } = useTranslation(["common"]);
  const resolvedConfirmLabel = confirmLabel ?? t("common:confirm.confirm");
  const resolvedCancelLabel = cancelLabel ?? t("common:confirm.cancel");
  const { forced, onClose, shakeControls } = useConfirmDialogContext();

  function handleCancel() {
    if (forced) {
      shakeControls.start({
        x: [0, -6, 6, -4, 4, 0],
        transition: { duration: 0.4 },
      });
      return;
    }

    if (onCancel) {
      onCancel();
    } else {
      onClose();
    }
  }

  const showCancel = cancelLabel !== "";

  return (
    <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-border">
      {showCancel && (
        <Button
          variant="ghost"
          onClick={handleCancel}
          disabled={loading}
          className="bg-card-hover hover:bg-card-hover/80 text-primary"
        >
          {resolvedCancelLabel}
        </Button>
      )}

      <Button
        variant={variant === "danger" ? "danger" : "primary"}
        onClick={onConfirm}
        disabled={loading || confirmDisabled}
        loading={loading}
      >
        {resolvedConfirmLabel}
      </Button>
    </div>
  );
}
